import albumOneUrl from "@/assets/gallery/albums_image_1.jpeg"
import albumTwoUrl from "@/assets/gallery/albums_image_2.jpg"
import albumThreeUrl from "@/assets/gallery/albums_image_3.jpeg"
import albumFourUrl from "@/assets/gallery/albums_image_4.jpg"
import albumFiveUrl from "@/assets/gallery/albums_image_5.jpg"
import albumSixUrl from "@/assets/gallery/albums_image_6.jpeg"
import albumSevenUrl from "@/assets/gallery/albums_image_7.jpg"
import roomOneImageOne from "@/assets/gallery/rooms/room-1-image-1.jpg"
import roomOneImageTwo from "@/assets/gallery/rooms/room-1-image-2.jpg"
import roomOneImageThree from "@/assets/gallery/rooms/room-1-image-3.jpg"
import roomTwoImageOne from "@/assets/gallery/rooms/room-2-image-1.jpg"
import roomTwoImageTwo from "@/assets/gallery/rooms/room-2-image-2.jpg"
import roomTwoImageThree from "@/assets/gallery/rooms/room-2-image-3.jpg"
import roomThreeImageOne from "@/assets/gallery/rooms/room-3-image-1.jpg"
import roomThreeImageTwo from "@/assets/gallery/rooms/room-3-image-2.jpg"
import roomThreeImageThree from "@/assets/gallery/rooms/room-3-image-3.jpg"
import * as settingsService from "@/services/settingsService"
import type { GalleryAlbum, GalleryImage } from "@/services/settingsService"

const albumCovers = [
  albumOneUrl,
  albumTwoUrl,
  albumThreeUrl,
  albumFourUrl,
  albumFiveUrl,
  albumSixUrl,
  albumSevenUrl,
]

const roomOneImages = [roomOneImageOne, roomOneImageTwo, roomOneImageThree]
const roomTwoImages = [roomTwoImageOne, roomTwoImageTwo, roomTwoImageThree]
const roomThreeImages = [roomThreeImageOne, roomThreeImageTwo, roomThreeImageThree]

function createImages(albumId: string, urls: string[]): GalleryImage[] {
  return urls.map((url, index) => ({
    id: `${albumId}-${index + 1}`,
    url,
    uploadedAt: "",
  }))
}

export const STATIC_GALLERY_ALBUMS: GalleryAlbum[] = [
  {
    id: "nha-cam-overview",
    title: "Không gian tổng thể",
    description:
      "Khám phá toàn cảnh Nhà Cam với không gian xanh mát, thoáng đãng và gần gũi thiên nhiên. Mỗi góc nhỏ đều được chăm chút tỉ mỉ.",
    cover: albumOneUrl,
    images: createImages("nha-cam-overview", [
      ...roomOneImages,
      ...roomTwoImages,
      ...roomThreeImages,
      ...albumCovers,
    ]),
  },
  {
    id: "nha-cam-chill",
    title: "Phòng Cam Chill",
    description:
      "Không gian nghỉ ngơi dịu nhẹ với ánh đèn ấm, tiện nghi vừa đủ và cảm giác thật thư thái.",
    cover: albumTwoUrl,
    images: createImages("nha-cam-chill", [albumTwoUrl, ...roomOneImages]),
  },
  {
    id: "nha-cam-52hz",
    title: "Phòng 52HZ",
    description:
      "Một căn phòng cá tính với ánh sáng đa sắc, góc thư giãn đầy riêng tư và tiện nghi chỉn chu.",
    cover: albumThreeUrl,
    images: createImages("nha-cam-52hz", [albumThreeUrl, ...roomTwoImages]),
  },
  {
    id: "nha-cam-details",
    title: "Chi tiết thủ công",
    description:
      "Những chất liệu mộc mạc và đường nét thủ công tạo nên sự gần gũi trong từng góc nhỏ.",
    cover: albumFourUrl,
    images: createImages("nha-cam-details", [
      albumFourUrl,
      roomOneImageThree,
      roomTwoImageTwo,
      roomThreeImageOne,
    ]),
  },
  {
    id: "nha-cam-canvas",
    title: "Phòng Canvas & Coco",
    description:
      "Không gian sáng thoáng, tối giản và mềm mại dành cho một kỳ nghỉ thật nhẹ nhàng.",
    cover: albumFiveUrl,
    images: createImages("nha-cam-canvas", [albumFiveUrl, ...roomThreeImages]),
  },
  {
    id: "nha-cam-oasis",
    title: "Phòng Cam Oasis",
    description:
      "Góc ngâm mình riêng tư kết hợp ánh sáng và âm nhạc cho những phút giây đáng nhớ.",
    cover: albumSixUrl,
    images: createImages("nha-cam-oasis", [albumSixUrl, ...roomTwoImages]),
  },
  {
    id: "nha-cam-moments",
    title: "Khoảnh khắc đáng nhớ",
    description:
      "Những khoảng sáng bình yên và tiện nghi thân thuộc được lưu lại trong hành trình tại Nhà Cam.",
    cover: albumSevenUrl,
    images: createImages("nha-cam-moments", [albumSevenUrl, ...albumCovers.slice(0, 4)]),
  },
]

export function resolveGalleryImageUrl(path: string): string {
  if (path.startsWith("/src/") || path.includes("/assets/")) return path
  return settingsService.getFullImageUrl(path)
}
